<div class="icon-box__icon-wrapper">
  <mat-icon class="icon-box__icon"
    [svgIcon]="to.icon"></mat-icon>
</div>
<div class="icon-box__field-wrapper">
  <ng-container #fieldComponent></ng-container>
</div>